import { Link } from "react-router-dom";
import { startCheckout } from "@/lib/checkout";
import { ShoppingCart } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel" className="max-w-md mx-auto px-6 py-24 text-center animate-fade-up">
      <div className="w-16 h-16 rounded-2xl bg-black/5 flex items-center justify-center mx-auto mb-6">
        <ShoppingCart className="w-7 h-7 text-nerd-light/70" />
      </div>
      <h1 className="font-display text-3xl font-extrabold mb-2">Checkout cancelled</h1>
      <p className="text-nerd-light/55 mb-8">No worries — you haven't been charged. You can upgrade whenever you're ready.</p>
      <div className="flex items-center justify-center gap-2">
        <button data-testid="retry-checkout-btn" onClick={startCheckout}
          className="inline-flex items-center gap-2 bg-nerd-light text-white px-6 py-3 rounded-full text-sm font-bold hover:opacity-90 transition-opacity">
          Try again — €8.99/mo
        </button>
        <Link to="/" className="inline-flex items-center gap-2 border border-black/12 px-6 py-3 rounded-full text-sm font-semibold hover:bg-black/5 transition-colors">
          Back to Discover
        </Link>
      </div>
    </div>
  );
}
